<div class="close-cross">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="patientHistoricDialog">
  <mat-card>
    <h3>{{ "alerts.historic" | translate }}</h3>
    <mat-card style="padding: 0px !important">
      <table mat-table matSort matSortDirection="desc" matSortActive="modified" [dataSource]="dataSource">
        <!-- modified Column -->
        <ng-container matColumnDef="modified">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.creationDate" | translate }}
            <app-item-filter
              fieldName="{{ 'table.creationDate' | translate }}"
              propertyName="modified"
              [dataType]="dataTypeDate"
              [defaultValue]="activeFilters | filterFor : 'modified'"
              (applyFilter)="applyFilter($event)"
            >
            </app-item-filter>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.modified | safeDate : "short" }}
          </td>
        </ng-container>
        <!-- date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.actionStartDate" | translate }}
            <app-item-filter
              fieldName="{{ 'table.actionStartDate' | translate }}"
              propertyName="date"
              [dataType]="dataTypeDate"
              [defaultValue]="activeFilters | filterFor : 'date'"
              (applyFilter)="applyFilter($event)"
            >
            </app-item-filter>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.date | safeDate : "short" }}
          </td>
        </ng-container>
        <!-- Author Column -->
        <ng-container matColumnDef="author">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.author" | translate }}
            <app-item-filter
              fieldName="{{ 'model.patient.name' | translate }}"
              propertyName="author.display"
              [dataType]="dataTypeText"
              [defaultValue]="activeFilters | filterFor : 'author.display'"
              (applyFilter)="applyFilter($event)"
            >
            </app-item-filter>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.author?.display }}
          </td>
        </ng-container>
        <!-- oldReason Column -->
        <ng-container matColumnDef="oldReason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.exValue" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.oldReason | disabledReasonKey | translate }}
          </td>
        </ng-container>
        <!-- newReason Column -->
        <ng-container matColumnDef="newReason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.newValue" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.newReason | disabledReasonKey | translate }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator #paginator [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" [hidePageSize]="false"> </mat-paginator>
    </mat-card>
  </mat-card>
</div>
